import * as React from "react";
import "./index.css";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { register } from "../../store/actions/userActions";
import { useEffect } from "react";
import Loader from "../../Components/Loader";
import MessageBox from "../../Components/MessageBox";
import { useNavigate } from "react-router-dom";
export default function RegisterScreen(props) {
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userRegister = useSelector((state) => state.userRegister);
  const { loading, error } = userRegister;

  const userSignin = useSelector((state) => state.userSignin);
  const { userInfo } = userSignin;

  const { search } = useLocation();
  const redirectInUrl = new URLSearchParams(search).get("redirect");
  const redirect = redirectInUrl ? redirectInUrl : "/";

  const submitHandler = (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      alert("Password are not same");
    } else {
      dispatch(register(name, email, password));
    }
  };

  useEffect(() => {
    if (userInfo) {
      navigate(redirect);
    }
  }, [redirect, userInfo, navigate]);

  return (
    <>
      <div className="imageOverlayContainerRegister">
        <h1>Register</h1>
        <div className="colorOverlayRegister"></div>
      </div>
      <div className="signinContainer container-fluid my-5 container">
        {error && (
          <MessageBox variant="danger">
            {error === "E11000" ? "Email already in use" : error}
          </MessageBox>
        )}
        {loading ? (
          <Loader></Loader>
        ) : (
          <form action="" onSubmit={submitHandler}>
            <div className="loginFields d-flex justify-content-center">
              <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                <div>
                  <TextField
                    id="outlined-basic"
                    type="text"
                    label="Name"
                    variant="outlined"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    sx={{ mt: 2, width: "32ch" }}
                    required={true}
                  />
                  <br />
                  <TextField
                    id="outlined-basic2"
                    type="text"
                    label="Email"
                    variant="outlined"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    sx={{ mt: 2, width: "32ch" }}
                    error={error ? true : false}
                    required={true}
                  />
                  <br />
                  <TextField
                    id="outlined-password-input"
                    label="Password"
                    type="password"
                    value={password}
                    autoComplete="current-password"
                    sx={{ mt: 2, width: "32ch" }}
                    onChange={(e) => setPassword(e.target.value)}
                    required={true}
                  />
                  <br />
                  <TextField
                    id="outlined-password-input2"
                    label="Confirm Password"
                    type="password"
                    value={confirmPassword}
                    autoComplete="current-password"
                    sx={{ mt: 2, width: "32ch" }}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required={true}
                  />
                  <div className="signinButton d-flex justify-content-center mt-4">
                    <Button
                      type="submit"
                      variant="contained"
                      className="w-100 bg-warning text-dark"
                    >
                      Register
                    </Button>
                  </div>
                  <div className="signinNewUser d-flex justify-content-start mt-4">
                    Already Have an account? &nbsp;
                    <Link
                      to={`/signin?redirect=${redirect}`}
                      className="tdnone"
                    >
                      Click here to signin
                    </Link>
                  </div>
                </div>
              </Box>
            </div>
          </form>
        )}
      </div>
    </>
  );
}
